import type { Building } from "building-types/building/buildingTypes";
import type { WallPlaneOpeningDomainOperationsByPlaneHash } from "building-types/walls2/wallPlane";
import { generateWallPlaneOpeningDomainOperations as computeWallPlaneOpeningDomainOperations } from "../elements/walls2/wallPlaneOpeningOperations";
import makeGenerationStageComparator from "../utils/makeGenerationStageComparator";
import memo from "../utils/memo";

function select({
  windowPlacements,
  doorPlacements,
  buildingGraph,
  planarGraphs,
  enabledFeatures,
}: Pick<Building, "windowPlacements" | "doorPlacements" | "buildingGraph" | "planarGraphs" | "enabledFeatures">) {
  return {
    windowPlacements,
    doorPlacements,
    buildingGraph,
    planarGraphs,
    enabledFeatures,
  };
}

const compare = makeGenerationStageComparator<typeof select>();

function generate({
  windowPlacements,
  doorPlacements,
  buildingGraph,
  planarGraphs,
  enabledFeatures,
}: ReturnType<typeof select>): Pick<Building, "wallPlaneOpeningDomainOperations"> {
  if (!enabledFeatures.wallPlanes) {
    return { wallPlaneOpeningDomainOperations: {} };
  }

  const wallPlaneOpeningDomainOperations: WallPlaneOpeningDomainOperationsByPlaneHash =
    computeWallPlaneOpeningDomainOperations({
      windowPlacements,
      doorPlacements,
      buildingGraph,
      planarGraphs,
    });

  return { wallPlaneOpeningDomainOperations };
}

export default memo(select, generate, compare);
